import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div className="text-center flex flex-col justify-center min-h-screen text-lg">
      <h1>Oops!</h1>

      <p>This page does not exist.</p>

      <Link to="/" className="text-blue-700 font-bold underline">
        Home
      </Link>
    </div>
  );
}
